import {combineReducers} from 'redux';

import srpPageReducer from './pages/SRP/redux/reducers';
import offerWidgetReducer from './pages/SRP/offer-widget-redux/reducers';
// import smartEngageReducer from './pages/SRP/smart-engage-redux/reducers';
import destinationsReducer from './pages/HomePage/destinations-redux/reducers';
import detailsPageReducer from './pages/DetailsPage/redux/reducers';
import commonReducer from './pages/common/redux/reducers';
import ugcReducer from './pages/UGC/redux/reducer';
import homePageReducer from './pages/HomePage/redux/reducers';
import mapsReducer from './pages/HotelsMap/redux/reducer';
import {reviewReducer} from '@ibibo/hotels-review-reducer';
import {thankYouReducer} from '@ibibo/hotels-thankyou-reducer';
import {myAccountReducer} from '@ibibo/myaccount-reducer';
import {smartEngageReducer} from '@ibibo/hotels-smartengage-store';
import shareHotelReducer from './pages/ShareHotel/redux/reducers';

const reducerList = {
  srp: srpPageReducer,
  details: detailsPageReducer,
  common: commonReducer,
  home: homePageReducer,
  ugc: ugcReducer,
  offerWidget: offerWidgetReducer,
  smartEngage: smartEngageReducer,
  destinations: destinationsReducer,
  review: reviewReducer,
  thankyou: thankYouReducer,
  maps: mapsReducer,
  myaccount: myAccountReducer,
  share: shareHotelReducer
};

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;
